import script from "./CompanyconfirmView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyconfirmView.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyconfirmView.vue?vue&type=style&index=0&id=741d36ce&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-741d36ce"]])

export default __exports__